import React from "react";
import Link from "../Link";
import Icon from "../Icon";
import Image from "../Image";
import Paragraph from "../Paragraph";
import { classes } from "../utils/classes";
import pureProps, { deepMergeProps } from "../utils/pureProps";
import { sxProps } from "../props/sx";

const BlockIcon = ({ ...props }) => (
	<div className="topbar-block-link-icon">
		<Icon size="s" name="link-ext" {...props} />
	</div>
);

const BlockImage = ({ ...props }) => <Image sizing={{ h: 6, w: "auto" }} {...props} />;

const BlockDescription = ({ sx = { ...sxProps }, children, ...props }) => (
	<Paragraph sx={deepMergeProps({ fontColor: "white", fontSize: "xs" }, pureProps(sx))} {...props}>
		{children}
	</Paragraph>
);

BlockDescription.propTypes = {
	...Paragraph.propTypes,
};

const MegaMenuBlockLink = ({ className, children, ...props }) => {
	return (
		<Link className={classes("topbar-block-link", className)} {...props}>
			{children}
		</Link>
	);
};

MegaMenuBlockLink.propTypes = {
	...Link.propTypes,
};

MegaMenuBlockLink.Icon = BlockIcon;
MegaMenuBlockLink.Image = BlockImage;
MegaMenuBlockLink.Description = BlockDescription;

export default MegaMenuBlockLink;
